<template>
    <div justify="center">  
        <v-dialog
            v-model="isDialog"
            max-width="650"
            content-class="elevation-0 rounded-0"
            transition="hide-on-leave"
        >
            <v-card
                class="rounded-0 pa-0 seoul-mini-semina-modal"
                outlined
                color="#00489d"
            >
                <div class="d-flex">
                    <v-img
                        :src="require('@/assets/img/main-modal/bg-seoul-mini-semina.jpg')"
                        alt=""
                    />                    
                </div>

                <div class="text">
                    <ul class="pra">
                        <li>
                            <span
                                class="d-flex align-center"
                                style="position: relative; width: auto;"
                            >
                                <span
                                    class="d-flex align-center"
                                    style="position: relative; padding-right: 55px;"
                                >
                                    <span>• 일시: <span style="color: #ff6442">2025년 5월 21일 (수)</span> 오전 10시</span>
                                    <span style="position: absolute; right: 0;">
                                        <v-img
                                            :src="require('@/assets/img/main-modal/ico-live-stream.png')"
                                            alt=""
                                            width="45"
                                            height="45"
                                            contain
                                        />
                                    </span>
                                </span>                                
                            </span>
                        </li>
                        <li>• 주제: <span style="color: #ffec5e">디지털 배지란 무엇인가?</span></li>
                        <li>• 연사: 노원석 대표 (㈜레코스)</li>
                        <li>
                            • 참여방법: <span class="fsize-m">실시간 온라인 화상회의 참여 (Zoom 활용)</span><br />
                            <div
                                class="fsize-s"
                                style="padding-left: 20px;"
                            >
                                * 접속URL: https://us06web.zoom.us/j/88242988020<br />
                                * 회의ID: 882 4298 8020 / 비밀번호없음
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="d-flex justify-center pb-10 pt-6">
                    <v-btn
                        href="https://forms.gle/au23dEui9TYf8SuCA"
                        target="_blank"
                        color="orange1"
                        depressed
                        :large="$vuetify.breakpoint.smAndUp"
                        class="text-white1"
                    >
                        사전 신청 바로가기
                    </v-btn>
                </div>

                <v-card
                    class="rounded-0 pa-0"
                    color="#efefef"
                >
                    <v-card-actions class="pa-0">
                        <button
                            block
                            tile
                            text
                            style="font-weight: normal; flex: 1;"
                            :style="{
                                'font-size' : $vuetify.breakpoint.xsOnly ? '12px' : '14px',
                                'min-height': $vuetify.breakpoint.xsOnly ? '30px' : '38px'
                            }"
                            :ripple="false"
                            @click="hideForOneDay"
                        >
                            오늘 하루 보지 않기
                        </button>

                        <button
                            block
                            tile
                            text
                            style="font-weight: normal; flex: 1; border-left: 1px solid #dcdcdc;"
                            :style="{
                                'font-size' : $vuetify.breakpoint.xsOnly ? '12px' : '14px',
                                'min-height': $vuetify.breakpoint.xsOnly ? '30px' : '38px'
                            }"
                            @click="closeDialog"
                        >
                            닫기
                        </button>
                    </v-card-actions>
                </v-card>
            </v-card>
        </v-dialog>
    </div>
</template>

<style>
.seoul-mini-semina-modal {
    .pra {
        padding-left: 40px !important;
        padding-top: 10px;

        @media (max-width: 650px) {
            padding-left: 20px !important;
        }

        @media (max-width: 400px) {
            padding-left: 15px !important;
        }
    }

    .text {
        /* position: absolute;
        left: 6%;
        top: 45%; */
        display: flex;
        color: #fff;
        font-size: 18px;
        line-height: 1.8;
        padding-bottom: 20px;

        .fsize-m {
            font-size: 16px;
        }

        .fsize-s {
            font-size: 14px;
        }

        @media (max-width: 650px) {
            font-size: 14px;
            .fsize-m {
                font-size: 14px;
            }

            .fsize-s {
                font-size: 12px;
            }
        }

        @media (max-width: 500px) {
            font-size: 12px;
            .fsize-m {
                font-size: 12px;
            }

            .fsize-s {
                font-size: 12px;
            }
        }
    }
}
</style>

<script>
import Cookies from 'js-cookie';

export default {
    name: 'NewYearModal2025',
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
    },
    data () {
        return {
            isDialog: this.dialog,
            // dialog: true,
        };
    },
    mounted() {
        // 페이지 로드 시 쿠키 확인
        const hideModal = Cookies.get('hideNewYearModal2025');
        if (hideModal) {
            this.isDialog = false;
        }
    },
    methods: {
        hideForOneDay() {
            // 쿠키에 1일 동안 유지되도록 값 저장
            Cookies.set('hideNewYearModal2025', 'true', { expires: 1 });
            this.isDialog = false;
            // this.$emit('update:dialog', false);
        },
        closeDialog() {
            this.isDialog = false;
            // this.$emit('update:dialog', false);
        },
    },
};
</script>
